import { UUID } from 'v2/core/entities/uuid';
import { NormalisedNode } from 'v2/querybuilder/types/querystore';
import { getDepthOfFilter } from './getDepthOfFilter';

interface ErrorNode {
  filterID: UUID;
  message: string;
}

export const getErrorNode = (
  nodes: Record<string, NormalisedNode>,
  currentNodeID: UUID,
  filters: Set<string> = new Set(),
): ErrorNode | null => {
  const currentNode = nodes[currentNodeID];

  if (currentNode.type === 'filter' && currentNode.field === 'category') {
    if (filters.has(currentNode.field)) {
      return {
        filterID: currentNode.id,
        message:
          "Hold your horses! You can't filter 'Category' twice in the same group for now.",
      };
    }

    filters.add(currentNode.field);
  }

  if (currentNode.type === 'group') {
    const newCategories = new Set<string>();
    for (const childID of currentNode.children) {
      const errorNode = getErrorNode(nodes, childID, newCategories);
      if (errorNode) {
        return errorNode;
      }
    }
  }

  const nestedFilterDepth = getDepthOfFilter(nodes, currentNodeID);

  if (nestedFilterDepth > 3) {
    return {
      filterID: currentNodeID,
      message:
        'Hold your horses! Filters are getting complex. We suggest you reduce the nesting to up to 2 levels.',
    };
  }

  return null;
};
